import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreator from '../../store/actions/index';
import { withRouter } from "react-router-dom";
import {
    withStyles, Dialog, DialogContent, DialogTitle, DialogActions,
    Table, TableContainer, TableHead, TableBody, TableRow, TableCell,
    TextField, IconButton
} from "@material-ui/core";
import t from "../../languages/pl";
import CancelAcceptForm from "./CancelAcceptForm";
import CustomCheckbox from "./CustomCheckbox";
import { themeTypeToBool } from '../../utils/helpers';
import NoData from './NoDataRow';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = theme => ({
    container: {
        margin: theme.spacing(2),
        marginTop: theme.spacing(1),
        padding: theme.spacing(1),
    },
    tableContainer: {
        height: "55vh"
    },
    cell: {
        padding: theme.spacing(1)
    },
    filters: {
        display: "flex",
        justifyContent: "flex-start",
        paddingBottom: theme.spacing(1),
        marginLeft: theme.spacing(11)
    },
    csvReader: {
        display: "none"
    },
    title: {
        paddingBottom: 0
    },
    textfield: {
        margin: theme.spacing(1)
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
    },
    buttonLabel: {
        color: "#FFF"
    }
});

const changeCarSelection = (id, state, availableElements) => {
    return availableElements.map(car => {
        if (car.kierowca_id === id) {
            car.selected = state;
            return car;
        }
        return car;
    });
};

const changeCollectionCarsState = (state, collectionToChange, availableElements) => {
    return availableElements.map(element => {
        if (collectionToChange.find(item => item.kierowca_id === element.kierowca_id))
            element.selected = state;
        return element;
    });
};

const ClearInput = ({ onClick }) => {

    return (
        <IconButton
            style={{ padding: 0 }}
            onClick={onClick}>
            <CloseIcon fontSize="small" />
        </IconButton>
    );
};
ClearInput.propTypes = { onClick: PropTypes.func };

const AssignDriversDialog = props => {
    const { classes, theme, open, onClose, onSubmit, title,
        availableDrivers, driversInGroup, checkedOption
    } = props;
    const [visibleDrivers, setVisibleDrivers] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [searchDriver, setSearchDriver] = useState("");
    const [selectedDriversCount, setSelectedDriversCount] = useState(0);

    useEffect(() => {
        setSelectedDriversCount(drivers.filter(car => car.selected === true).length);
    }, [drivers]);

    useEffect(() => {
        let expandedDrivers = availableDrivers.map(availableDriver => {
            if (driversInGroup.find(driverId => driverId === availableDriver.kierowca_id))
                availableDriver.selected = true;
            else availableDriver.selected = false;
            return availableDriver;
        });
        setDrivers(expandedDrivers);
        setVisibleDrivers(expandedDrivers);
    }, [availableDrivers, driversInGroup]);

    const handleSubmit = () => {
        let driversToAssign = drivers.filter(driver => driver.selected);
        let driverIds = driversToAssign.map(driver => driver.kierowca_id);
        if (onSubmit)
            onSubmit(driverIds);
    };

    const handleToggle = (id, e) => {
        setDrivers(changeCarSelection(id, e.target.checked, drivers));
    };

    const handleToggleAll = (e) => {
        let newCars = changeCollectionCarsState(e.target.checked, visibleDrivers, drivers);
        setDrivers(newCars);
    };

    const handleSearchDriverChange = (e) => {
        setSearchDriver(e.target.value);
        let filteredDrivers = availableDrivers.filter(driver => {
            if (driver.kierowca_nazwa.toLowerCase().includes(e.target.value.toLowerCase()))
                return driver;
        });
        setVisibleDrivers(filteredDrivers);
    };

    const handleSearchClear = () => {
        setSearchDriver("");
        setVisibleDrivers(drivers);
    };

    const printList = data => {
        if (!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={3} />;
        return data.map(row => {
            return (
                <TableRow key={row.kierowca_id}>
                    <TableCell className={classes.cell}>
                        <CustomCheckbox
                            style={{ color: themeTypeToBool(theme.palette.type) ? "#6B6E77" : "#FAFAFA" }}
                            checked={row.selected}
                            onChange={handleToggle.bind(this, row.kierowca_id)}
                        />
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.kierowca_nazwa}
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle className={classes.title}>
                {t.assignDrivers}&nbsp;{title}
            </DialogTitle>
            <DialogContent className={classes.container}>
                <div>
                    {props.children}
                </div>
                {checkedOption === 1 ?
                    <React.Fragment>
                        <div className={classes.filters}>
                            <TextField
                                label={t.find}
                                InputLabelProps={{
                                    classes: { root: classes.label }
                                }}
                                className={classes.textfield}
                                InputProps={{
                                    endAdornment: <ClearInput onClick={handleSearchClear} />
                                }}
                                value={searchDriver}
                                onChange={handleSearchDriverChange}
                            />
                        </div>
                        <TableContainer className={classes.tableContainer}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.cell}>
                                            <CustomCheckbox
                                                style={{ color: themeTypeToBool(theme.palette.type) ? "#6B6E77" : "#FAFAFA" }}
                                                onChange={handleToggleAll}
                                            />
                                        </TableCell>
                                        <TableCell className={classes.cell}>
                                            {t.firstName}&nbsp;i&nbsp;{t.lastName}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {printList(visibleDrivers)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </React.Fragment>
                    : null}
            </DialogContent>
            <DialogActions>
                <CancelAcceptForm
                    onCancel={onClose}
                    onSubmit={handleSubmit}
                    disableSubmit={selectedDriversCount === 0}
                />
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => ({
    availableDrivers: state.driverReducer.availableDrivers
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

AssignDriversDialog.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    open: PropTypes.bool,
    title: PropTypes.string,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    children: PropTypes.node,
    driversInGroup: PropTypes.array,
    checkedOption: PropTypes.number,
    //redux
    availableDrivers: PropTypes.array,
    notifyError: PropTypes.func
};

AssignDriversDialog.defaultProps = {
    availableDrivers: [],
    driversInGroup: []
};

export default compose(
    withStyles(useStyles, { withTheme: true }),
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(AssignDriversDialog);
